import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { SendMail } from "../../lib/api";
import { toast } from "react-toastify";
import Spinner from "../../components/ui/loader";

function ScheduleDemo() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const mutateSendMail = useMutation({
    onMutate: () => {
      setIsSubmitting(true);
    },
    mutationFn: (data) => {
      const response = SendMail(data);
      return response;
    },
    onSuccess: () => {
      toast.success("Successfully send mail");
    },
    onError: () => {
      toast.error("Send Mail Failed!");
    },
    onSettled: () => {
      reset();
      setIsSubmitting(false);
    },
  });

  const onSubmit = (data) => {
    const formData = {
      ...data,
      subject: "Get A Free Demo",
    };
    mutateSendMail.mutate(formData);
  };
  return (
    <div className="w-full md:w-3/4 m-auto border border-[#FD7702] px-6 py-16 rounded-2xl mt-6">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="m-auto">
          <img src="\images\home\schedule_demo.svg" alt="schedule_demo" />
        </div>
        <div className="flex items-center justify-center poppins_light p-4">
          <div className="bg-white w-full max-w-md">
            <h2 className="text-xl sm:text-2xl poppins_bold mb-2">
              Schedule a free demo
            </h2>
            <p className="text-gray-600 mb-6">
              Get in touch with our team to clarify your queries
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Name
                  <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  {...register("firstName", { required: "Enter Name" })}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none border-[#FB824D] bg-[#FFF8E9]"
                  required
                />
                {errors.firstName && (
                  <span className="ml-5 text-red-600">
                    {errors.firstName.message}
                  </span>
                )}
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mb-4">
                <div className="sm:w-1/2">
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number<span className="text-red-600">*</span>
                  </label>
                  <input
                    type="tel"
                    id="number"
                    name="number"
                    {...register("number")}
                    className="w-full px-3 py-2 border border-[#FB824D] bg-[#FFF8E9] rounded-md focus:outline-none "
                    required
                  />
                  {errors.number && (
                    <span className="ml-5 text-red-600">
                      {errors.number.message}
                    </span>
                  )}
                </div>
                <div className="sm:w-1/2">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Email<span className="text-red-600">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    {...register("email")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none border-[#FB824D] bg-[#FFF8E9]"
                    required
                  />
                  {errors.email && (
                    <span className="ml-5 text-red-600">
                      {errors.email.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="mb-4">
                <label
                  htmlFor="city"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  City<span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="place"
                  name="place"
                  {...register("place")}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none border-[#FB824D] bg-[#FFF8E9]"
                  required
                />
                {errors.place && (
                  <span className="ml-5 text-red-600">
                    {errors.place.message}
                  </span>
                )}
              </div>

              <div className="mb-4">
                <label
                  htmlFor="shopType"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Shop Type<span className="text-red-600">*</span>
                </label>
                <select
                  id="shopType"
                  name="shopType"
                  {...register("shopType")}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none border-[#FB824D] bg-[#FFF8E9]"
                  required
                >
                  <option value="" disabled selected>
                    Choose an option
                  </option>
                  <option value="retail">Retail</option>
                  <option value="online">Online</option>
                </select>
                {errors.shopType && (
                  <span className="ml-5 text-red-600">
                    {errors.shopType.message}
                  </span>
                )}
              </div>

              <div className="mb-6">
                <label
                  htmlFor="shopName"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Shop Name<span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="shopName"
                  name="shopName"
                  {...register("shopName")}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none border-[#FB824D] bg-[#FFF8E9]"
                  required
                />
                {errors.shopName && (
                  <span className="ml-5 text-red-600">
                    {errors.shopName.message}
                  </span>
                )}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="poppins_medium w-full bg-orange-500 text-white hover:text-white py-2 px-4 rounded-md hover:bg-orange-600 focus:outline-none mx-0"
              >
                {isSubmitting ? <Spinner /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ScheduleDemo;
